export default __webpack_public_path__ + "static/media/8 Swarna Velli Jewels Logo.png.a66f0ae3.png";